'use client'
import { detectIncognito } from 'detectincognitojs'
import { useEffect, useState } from 'react'

export default function BrowserCheck() {
  const [isInvalidBrowser, setIsInvalidBrowser] = useState(false)

  useEffect(() => {
    detectIncognito().then((isIncognito) => {
      if (isIncognito.isPrivate && isIncognito.browserName === 'Safari') {
        setIsInvalidBrowser(true)
      }
    })
  }, [])

  return (
    <div>
      {isInvalidBrowser && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
          <div className="w-full max-w-sm rounded-lg bg-white p-6 text-center shadow-lg">
            <h2 className="mb-2 text-xl font-bold text-red-600">Browser Not Supported</h2>
            <p className="mb-4 text-gray-800">
              Safari &quot;Private Browsing&quot; or &quot;Incognito&quot; mode is not supported.
              Please disable private browsing or use another browser.
            </p>
            <h3 className="text-gray-800">See list of supported browsers.</h3>
            <ol className="flex flex-col px-12 text-gray-800">
              <li className="flex gap-2">
                <span>-</span>
                <span>Chrome</span>
              </li>
              <li className="flex gap-2">
                <span>-</span>
                <span>Edge</span>
              </li>
              <li className="flex gap-2">
                <span>-</span>
                <span>Firefox</span>
              </li>
              <li className="flex gap-2">
                <span>-</span>
                <span>Safari (default browsing mode)</span>
              </li>
            </ol>
          </div>
        </div>
      )}
    </div>
  )
}
